// extracted by mini-css-extract-plugin
export var fadeInAnimation = "Steps-module--fadeInAnimation--bb062";
export var step = "Steps-module--step--c63fb";
export var stepTitle = "Steps-module--stepTitle--28738";
export var title = "Steps-module--title--b1555";
export var wrapper = "Steps-module--wrapper--f4679";